import { CartDrawerPlaceholder, CartDrawerPlaceholderItem } from '@vs-shop/commerce-ui/cartDrawer';

/**
 * What the drawer shows in place of its items: on its first render, and again
 * while an empty cart is being refreshed.
 *
 * Two stand-ins rather than one — the number is this tenant's, chosen to fill
 * the panel's first screen.
 */
export default function CartDrawerItemPlaceholder() {
  return (
    <CartDrawerPlaceholder>
      <CartDrawerPlaceholderItem />
      <CartDrawerPlaceholderItem />
    </CartDrawerPlaceholder>
  );
}
